import { CalculateDimensions } from "../horizontal_scrollbar.types";

export const calculateForcedScrollableContainerDimensions = (
  clientX: number,
  {
    contentRef,
    scrollableContainer,
    scrollbarContainerRef,
    scrollbarRef
  }: Omit<
    CalculateDimensions,
    "scrollbarDraggingData" | "minThumbWidth" | "getContentWidth" | "getWindowWidth"
  >
) => {
  if (
    !scrollableContainer ||
    !scrollbarRef.current ||
    !contentRef.current ||
    !scrollbarContainerRef.current
  ) {
    return { scrollLeft: 0 };
  }

  const rect = scrollbarContainerRef.current.getBoundingClientRect();
  const clickX = clientX - rect.left;

  const scrollbarContainerWidth = scrollbarContainerRef.current.clientWidth;
  const thumbWidth = scrollbarRef.current.clientWidth;

  // Calculate available space for thumb movement
  const maxThumbLeft = scrollbarContainerWidth - thumbWidth;
  // Use scrollWidth (actual scrollable width) instead of contentWidth
  const maxScrollLeft = Math.max(0, scrollableContainer.scrollWidth - scrollableContainer.clientWidth);

  // Center thumb on click position, but clamp to available space
  const thumbLeft = Math.max(0, Math.min(clickX - thumbWidth / 2, maxThumbLeft));

  // Convert thumb position to scroll position using new ratio
  const scrollLeft = maxThumbLeft > 0 ? (thumbLeft / maxThumbLeft) * maxScrollLeft : 0;

  return { scrollLeft };
};
